import { ELOQUENT } from '../config/constants';

export function getAllProducts(query) {
    return ELOQUENT.Product.getAll(query);
}

export function getProductById(id) {
    return ELOQUENT.Product.getOne(id);
}

export function createProduct(data) {
    return ELOQUENT.Product.createOne(data);
}

export function updateProduct(id, data) {
    return ELOQUENT.Product.updateOne(id, data);
}

export function deleteProduct(id) {
    return ELOQUENT.Product.deleteOne(id);
}

export function publishProduct(id) {
    return ELOQUENT.Product.publish(id);
}

export function unPublishProduct(id) {
    return ELOQUENT.Product.unPublish(id);
}

export function getResultsByCategory(query) {
    return ELOQUENT.Search.getResultsByCategory(query);
}
